module.exports = __webpack_public_path__ + "img/process-order.8ccdbc31.png";